'use strict';

export default function saCarouselItem($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    require: '^saCarousel',
    link: function ($scope, $element, $attrs, saCarousel) {
      $element.addClass('Carousel-item');
      saCarousel.addItem($element);

      $timeout(() => $element.find('img').attr('draggable', 'false'));

      $element.on('$destroy', function () {
        saCarousel.removeItem($element);
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/common/carousel/carousel_item.directive.js